module.exports = __webpack_public_path__ + "static/media/arrow-top-left.219333be.svg";